module.exports = __webpack_public_path__ + "static/media/leadership-top-banner-mobile.f79ed68c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leadership/leadership-top-banner-mobile.png
// module id = 279
// module chunks = 0